import React from "react";

/**
 * Global Status Badge
 */

const statusStyles = {
  SUCCESS: "bg-green-100 text-green-700",
  FAILED: "bg-red-100 text-red-700",
  PARTIAL: "bg-yellow-100 text-yellow-700",
  RUNNING: "bg-blue-100 text-blue-700",
  PENDING: "bg-gray-100 text-gray-700",
  ACTIVE: "bg-green-100 text-green-700",
  INACTIVE: "bg-red-100 text-red-700",
  ENABLED: "bg-green-100 text-green-700",
  DISABLED: "bg-red-100 text-red-700",
};

const StatusBadge = ({ status }) => {
  return (
    <span
      className={`px-3 py-1 rounded-full text-xs font-semibold ${statusStyles[status?.toUpperCase()] || "bg-gray-100 text-gray-700"
        }`}
    >
      {status}
    </span>
  );
};

export default StatusBadge;